
const confirm = resolve =>{
  import('./confirm/confirm').then(module=>{
    resolve(module)
  })
}
const store_index = resolve =>{
  import('./store_index/store_index').then(module=>{
    resolve(module)
  })
}
const details = resolve =>{
  import('./details/details').then(module=>{
    resolve(module)
  })
}


export default [
  {
    path: '/store',
    name: 'store_index',
    component: store_index,
    meta: {
      auth: false,
      title: '在线商城',
      nav: true,
      keepAlive:true
    }
  },
  {
    name: 'confirm',
    path: '/pay/confirm',
    component: confirm,
    meta: {
      nav: false,
      auth: true,
      title: '确认订单',
      keepAlive: false
    }
  },
  {
    name: 'details',
    path: '/store/details',
    component: details,
    meta: {
      nav: false,
      auth: false,
      title: '商品详情',
      keepAlive: false
    }
  }
]



// WEBPACK FOOTER //
// ./src/module/store/router.js